import VideoOptions from "./video_options"
import FirstVideoCelebration from "./first_video_celebration"
import vimeoManager from "vimeo_manager"
import {trackConsumedVideo} from "consumed_content"
import React from "react"
import modal from "../modal"

function EmbeddedVideo({
  title,
  htmlTitle,
  autoPlay,
  playTime,
  description,
  transcript,
  timestamps,
  vimeoId,
  vimeoThumbnailUrl,
  canWatchFullVideo,
  restricted,
  language,
  trackingData,
  showContentTabs,
  startTime
}) {
  const [iframe, setIframe] = React.useState()
  const [loadVimeoPlayer, setLoadVimeoPlayer] = React.useState(autoPlay)
  const [
    isVideoOptionsVisible,
    setIsVideoOptionsVisible
  ] = React.useState(false)
  const [
    showFirstVideoCelebration,
    setShowFirstVideoCelebration
  ] = React.useState(undefined)
  useVimeoVideo(
    trackingData.slug,
    iframe,
    setIsVideoOptionsVisible,
    setShowFirstVideoCelebration,
    startTime,
    autoPlay
  )
  function onClick() {
    if (restricted) {
      modal("#reg_wall_modal")
      return
    }

    setLoadVimeoPlayer(true)
  }
  React.useEffect(() => {
    if (startTime) {
      setLoadVimeoPlayer(true)
    }
  }, [startTime])
  const iframeSrc =
    `https://player.vimeo.com/video/${vimeoId}` +
    `?autoplay=1&muted=${autoPlay ? 1 : 0}`
  return (
    <div className="embedded-video">
      <div className="embedded-video--video">
        {!loadVimeoPlayer &&
          <picture>
            <img alt="" src={vimeoThumbnailUrl} onClick={onClick} />
          </picture>}
        {loadVimeoPlayer &&
          <iframe
            src={iframeSrc}
            id={`videos_vimeo_player_${vimeoId}`}
            data-video-tracking={JSON.stringify(trackingData)}
            data-video-language={language}
            ref={setIframe}
            webkitallowfullscreen=""
            mozallowfullscreen=""
            allowFullScreen={true}
            frameBorder="0"
            allow="autoplay"
            height="9"
            width="16"
          />}
      </div>
      {showFirstVideoCelebration &&
        <FirstVideoCelebration
          onClose={() => setShowFirstVideoCelebration(false)}
        />}
      {!showFirstVideoCelebration && isVideoOptionsVisible &&
        <VideoOptions
          vimeoId={vimeoId}
          iframe={iframe}
          timestamps={timestamps}
          transcript={transcript}
          canWatchFullVideo={canWatchFullVideo}
          showContentTabs={showContentTabs}
        />}
      {!showFirstVideoCelebration && !isVideoOptionsVisible &&
        <div className="embedded-video--content">
          <div className="embedded-video--title">
            {htmlTitle || `${title} [${playTime}]`}
          </div>
          <div className="embedded-video--description">{description}</div>
        </div>}
    </div>
  )
}

let firstVideoConsumed = false

function useVimeoVideo(
  slug,
  iframe,
  setIsVideoOptionsVisible,
  setShowFirstVideoCelebration,
  startTime,
  autoPlay
) {
  React.useEffect(() => {
    if (!iframe) return

    vimeoManager.initPlayer(iframe, {
      onUpdateTime: (data) => {
        if (!window.gon.currentUser) return
        if (window.gon.currentUser.videosConsumedCount > 0) {
          return
        }
        const percentageViewed = data?.percent || 0.0
        if (percentageViewed <= 0.85) return
        if (firstVideoConsumed) return
        firstVideoConsumed = true
        setShowFirstVideoCelebration(true)
      }
    })
    setIsVideoOptionsVisible(true)
    trackConsumedVideo(slug, iframe)

    if (startTime) {
      vimeoManager.playVideo(iframe, startTime)
    }

    if (autoPlay) {
      document.addEventListener("click", () => {
        vimeoManager.unmute(iframe)
      }, {once: true})
    }
  }, [iframe, startTime])
}

export default EmbeddedVideo
